<script>
import Details from '@/views/succezz/details.vue';
export default {
  mixins: [Details],
  data() {
    return {
      isExpand: false,
    };
  },
  methods: {
    renderDetails() {
      return (
        <Details>
          {this.renderAccordionButton()}
        </Details>
      );
    },
    renderDetailsForMobile() {
      return (<tile class='opc-succezz-order'>
        <h1 class='text-capitalize'>{this.$t('billing.order_summary')}</h1>
        <div class='opc-succezz-order__details'>
          {this.renderFirstCartPlan()}
          {this.renderFirstCartPlanSubTitle()}
          {this.renderFirstCartPlanDiscount()}
        </div>
        <div class='opc-succezz-order__expand'>
          {this.renderAccordionButton()}
        </div>
      </tile>);
    },
    renderAccordionButton() {
      const toggle = () => {
        this.$tracking.buyInteraction('purchase confirmation', `order summary - plans & billing - ${this.isExpand ? 'collapse' : 'expand'}`);
        this.isExpand = !this.isExpand;
      };
      const button = (text, icon) => (
        <zm-button tabindex='0' aria-expanded={this.isExpand ? 'true' : 'false'} type='link'
                   class='opc-cfgcore__addon__toggle opc-success-no-hide-button' onClick={toggle} suffix-icon={icon}>
          {text}
        </zm-button>
      );
      if (this.isExpand) return button(this.$t('billing.success.confirmation.show_less'), 'zm-icon-up');
      return button(this.$t('billing.success.confirmation.show_full_order_details'), 'zm-icon-down');
    },
    renderFirstCartPlanSubTitle() {
      return (<div class='opc-cart-item' style='margin-bottom: 8px;' domPropsInnerHTML={this.persistState?.confirmationDetails?.firstPlanSubtitleEle} />);
    },
    renderFirstCartPlan() {
      return (<div class='opc-cart-item' style='margin-bottom: 8px;' domPropsInnerHTML={this.persistState?.confirmationDetails?.firstPlanTitleEle} />);
    },
    renderFirstCartPlanDiscount() {
      const ele = this.persistState?.confirmationDetails?.firstPlanDiscountEle;
      return (ele ? <div class='opc-cart-item__discount' domPropsInnerHTML={ele} /> : null);
    },
  },
  render() {
    if (!this.isShowOrderDetails) return null;
    if (this.isExpand) {
      return this.renderDetails();
    }
    return this.renderDetailsForMobile();
  },
};
</script>
